import Icon from "@/components/common/icon";

export default function Max() {
  return (
    <a
      href="https://max.ru/id110603860118_bot"
      target="_blank"
      rel="noreferrer"
      id="maxLink"
    >
      <Icon id="max" />
    </a>
  );
}
